import MainButton from "../MainButton";
import { Link } from "react-router-dom";

function BlogBox({ img, title, description, date }) {
  return (
    <>
      <div className="flex flex-col gap-6">
        {img ? (
          <img src={img} alt="blog_img" className="w-full h-auto object-cover rounded-xl" />
        ) : (
          <div className="w-full h-[300px] bg-gray-200 flex items-center justify-center rounded-xl text-gray-400 font-bold">
            NO IMAGE
          </div>
        )}
        <p className="font-medium text-[14px] text-[#646464] pt-8 pb-4">
          <i className="fa-solid fa-layer-group text-[#ff0336] text-[16px]"></i>
          &nbsp; By <b>Admin</b> | {date || "Recently published"}
        </p>
        <h2 className="text-[3rem] font-bold mb-6">{title}</h2>
        <p className="font-medium text-[16px] text-[#646464] mb-12">
          {description}
        </p>
        <Link to="/contact">
          <MainButton
            color={`!text-white`}
            bg={`bg-[#ff0336]`}
            text="enquire now"
            arrowColor={`!text-white`}
            cN="pricing-cta blog-cta"
          />
        </Link>
      </div>
    </>
  );
}

export default BlogBox;
